module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_ring-b834d0bf836d7a55a3a8a4da0fbfeff7.png";